import _ from "lodash";
import i18next from "i18next";
import { LANGUAGE_OPTIONS } from "Constants";

export const loadLocalesBundle = async (
  value,
  languages = LANGUAGE_OPTIONS
) => {
  const filterLanguage = _.filter(
    languages,
    language => language.value === value
  );
  if (_.isEmpty(filterLanguage)) {
    return;
  }
  await import(
    /* webpackChunkName: "locales.[request]" */
    `Locales/${value}/index`
  )
    .then(resources => {
      _.forOwn(resources.default, (key, ns) => {
        i18next.addResourceBundle(value, ns, key);
      });

      // update lang attribute in html tag with the language code
      document.documentElement.lang = value;
    })
    .catch(() => {
      window.location.reload();
    });
};
